import { cn } from "@/lib/utils";

/** Concentric ring + centre dot — a pin dropped precisely on a target. */
export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <svg viewBox="0 0 24 24" className="size-5 text-primary" aria-hidden="true">
        <circle
          cx="12"
          cy="12"
          r="8"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          opacity="0.45"
        />
        <circle cx="12" cy="12" r="3.25" fill="currentColor" />
      </svg>
      <span className="font-semibold tracking-tight">Pinpoint</span>
    </div>
  );
}
